function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServerErrorImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.89,267.6s3.64,74.59,66.63,122.46,149.19,48.81,219,51.42,122.72-38.6,129.8-98.67-46.49-76-76.53-143.24S350,109.89,288.09,69.86,131,58.46,82,131.74,38.89,267.6,38.89,267.6Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.89,267.6s3.64,74.59,66.63,122.46,149.19,48.81,219,51.42,122.72-38.6,129.8-98.67-46.49-76-76.53-143.24S350,109.89,288.09,69.86,131,58.46,82,131.74,38.89,267.6,38.89,267.6Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.73,372.86s-3.4-14.45-.85-27.21,8.5-4.25,15.31-12.76,3.4-24.66,11.05-31.47,18.71-5.95,21.26-18.71,4.26-23,9.36-21.26-4.25,17-4.25,26.37,5.1,15.3,1.7,24.66-17.86,5.95-17.86,17,5.95,22.11.85,29.77-18.71,9.35-20.41,13.6-6,11.91-10.21,11.91S420.73,372.86,420.73,372.86Z",
    style: {
      fill: "#bfbfbf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,373c.85-2.55-.85-24.66-8.5-28.91s-16.16-2.55-20.41-10.21-4.26-11.05-8.51-11.9-24.66-4.26-22.11,0,17.86-2.56,17.86,5.95-1.7,22.11,3.4,25.51,18.71,2.55,17.86,10.21-3.4,10.2.85,12.76,16.16,13.6,17.86,5.1Z",
    style: {
      fill: "#bfbfbf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.43,391.77s-4-12.39,6.93-35.17,18.82-40.11,23.77-49",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.51,393.75s-1.48-5.95-6.44-22.29-10.89-20.8-19.31-26.25-8.91-14.36-10.4-16.84",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.31,384.83s1-8.91,8.92-11.39,15.35-1.48,16.84-6.93,1.48-10.9,4.95-13.87,7.92-4.46,8.42-3-5,2.48-5,7.43,7.43,17.33-3.46,22.28-19.81.5-23.77,4-6.44,5.94-6.44,5.94Z",
    style: {
      fill: "#bfbfbf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.32,393.75s3.47-12.88,11.89-15.85S468,381.37,472,375.42s1-11.88.49-15.84",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.89,391.77h-30.7a2.47,2.47,0,0,0-2.48,2.47h0a2.48,2.48,0,0,0,2.48,2.48h.25l2.39,6.27a2.57,2.57,0,0,0,2.4,1.65h20.63a2.58,2.58,0,0,0,2.4-1.65l2.39-6.27h.24a2.48,2.48,0,0,0,2.48-2.48h0A2.47,2.47,0,0,0,443.89,391.77Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 302.6,
    y: 250.74,
    width: 156.35,
    height: 28.04,
    rx: 4.73,
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.36,259.68v12.6H313v-12.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.41,272.28h-1.26v-12.6h1.78l2.91,9.11v-9.11h1.25v12.6h-1.46l-3.22-10.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.72,272.28V261H323.4v-1.28h6.05V261h-2.32v11.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.26,265.26v1.26h-3.08V271H336v1.28h-5.18v-12.6H336V261h-3.78v4.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.43,259.68c2,0,2.81,1,2.81,2.88v1c0,1.39-.49,2.25-1.57,2.6,1.15.34,1.58,1.28,1.58,2.63v2a3.07,3.07,0,0,0,.26,1.51h-1.43a3.33,3.33,0,0,1-.23-1.53v-2c0-1.42-.67-1.87-1.84-1.87h-1v5.38h-1.4v-12.6Zm-.36,5.94c1.11,0,1.78-.36,1.78-1.73v-1.21c0-1.13-.41-1.72-1.46-1.72H339v4.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.31,272.28h-1.26v-12.6h1.78l2.92,9.11v-9.11H351v12.6h-1.45l-3.23-10.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.21,269.74l-.48,2.54h-1.3l2.41-12.6h2l2.41,12.6h-1.4l-.49-2.54Zm.18-1.2h2.81l-1.42-7.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.75,272.28v-12.6h1.4V271h3.6v1.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.78,262.7V263h-1.33v-.41c0-1.13-.43-1.8-1.44-1.8s-1.44.67-1.44,1.78c0,2.83,4.23,3.1,4.23,6.64,0,1.91-.92,3.16-2.85,3.16s-2.82-1.25-2.82-3.16v-.71h1.31v.79c0,1.13.47,1.8,1.48,1.8s1.47-.67,1.47-1.8c0-2.81-4.21-3.08-4.21-6.63,0-1.94.9-3.15,2.79-3.15S375.78,260.79,375.78,262.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.86,265.26v1.26h-3.07V271h3.78v1.28h-5.19v-12.6h5.19V261h-3.78v4.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,259.68c2,0,2.81,1,2.81,2.88v1c0,1.39-.49,2.25-1.57,2.6,1.15.34,1.59,1.28,1.59,2.63v2a3.07,3.07,0,0,0,.25,1.51h-1.42a3.17,3.17,0,0,1-.24-1.53v-2c0-1.42-.66-1.87-1.83-1.87h-1v5.38h-1.41v-12.6Zm-.36,5.94c1.12,0,1.78-.36,1.78-1.73v-1.21c0-1.13-.41-1.72-1.46-1.72h-1.36v4.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.7,259.68l2.05,11,2-11h1.29l-2.36,12.6h-2.07l-2.37-12.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404,265.26v1.26h-3.08V271h3.79v1.28h-5.19v-12.6h5.19V261h-3.79v4.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.17,259.68c2,0,2.81,1,2.81,2.88v1c0,1.39-.49,2.25-1.57,2.6,1.15.34,1.59,1.28,1.59,2.63v2a3.07,3.07,0,0,0,.25,1.51h-1.42a3.17,3.17,0,0,1-.24-1.53v-2c0-1.42-.67-1.87-1.84-1.87h-1v5.38h-1.4v-12.6Zm-.36,5.94c1.11,0,1.78-.36,1.78-1.73v-1.21c0-1.13-.41-1.72-1.46-1.72h-1.37v4.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.44,265.26v1.26h-3.07V271h3.78v1.28H417v-12.6h5.19V261h-3.78v4.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.61,259.68c2,0,2.81,1,2.81,2.88v1c0,1.39-.49,2.25-1.57,2.6,1.15.34,1.59,1.28,1.59,2.63v2a3.19,3.19,0,0,0,.25,1.51h-1.42a3.17,3.17,0,0,1-.24-1.53v-2c0-1.42-.66-1.87-1.83-1.87h-1v5.38H423.8v-12.6Zm-.36,5.94c1.12,0,1.78-.36,1.78-1.73v-1.21c0-1.13-.41-1.72-1.46-1.72h-1.36v4.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.06,259.68c2,0,2.81,1,2.81,2.88v1c0,1.39-.49,2.25-1.57,2.6,1.16.34,1.59,1.28,1.59,2.63v2a3.19,3.19,0,0,0,.25,1.51h-1.42a3.3,3.3,0,0,1-.24-1.53v-2c0-1.42-.66-1.87-1.83-1.87h-1v5.38h-1.41v-12.6Zm-.36,5.94c1.12,0,1.78-.36,1.78-1.73v-1.21c0-1.13-.41-1.72-1.45-1.72h-1.37v4.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.6,262.72c0-1.93.95-3.17,2.88-3.17s2.9,1.24,2.9,3.17v6.52c0,1.91-1,3.17-2.9,3.17s-2.88-1.26-2.88-3.17Zm1.38,6.59c0,1.15.49,1.82,1.5,1.82s1.49-.67,1.49-1.82v-6.66c0-1.14-.47-1.82-1.49-1.82s-1.5.68-1.5,1.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.88,259.68c2,0,2.8,1,2.8,2.88v1c0,1.39-.48,2.25-1.56,2.6,1.15.34,1.58,1.28,1.58,2.63v2a3.07,3.07,0,0,0,.26,1.51h-1.43a3.33,3.33,0,0,1-.23-1.53v-2c0-1.42-.67-1.87-1.84-1.87h-1v5.38h-1.4v-12.6Zm-.36,5.94c1.11,0,1.78-.36,1.78-1.73v-1.21c0-1.13-.42-1.72-1.46-1.72h-1.37v4.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.12,221v5.85c0,4.5,2,6.12,5.13,6.12s5.13-1.62,5.13-6.12V213c0-4.5-2-6.21-5.13-6.21s-5.13,1.71-5.13,6.21v1.89h-9.36l1.8-36.54h26.1v9H338.47l-.81,15a9.44,9.44,0,0,1,8.64-4.59c7.29,0,11,5.13,11,14.4v14c0,10.08-5,15.84-14.76,15.84s-14.76-5.76-14.76-15.84V221Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.84,193.48c0-10.08,5.31-15.84,15-15.84s15,5.76,15,15.84v32.76c0,10.08-5.31,15.84-15,15.84s-15-5.76-15-15.84Zm9.9,33.39c0,4.5,2,6.21,5.13,6.21s5.13-1.71,5.13-6.21v-34c0-4.5-2-6.21-5.13-6.21s-5.13,1.71-5.13,6.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.28,193.48c0-10.08,5.31-15.84,15-15.84s15,5.76,15,15.84v32.76c0,10.08-5.31,15.84-15,15.84s-15-5.76-15-15.84Zm9.9,33.39c0,4.5,2,6.21,5.13,6.21s5.13-1.71,5.13-6.21v-34c0-4.5-2-6.21-5.13-6.21s-5.13,1.71-5.13,6.21Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Server--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153,338.54a23.83,23.83,0,0,1,17.68,4.4c8.17,6.28,14.38,22.25,17.59,44.61s5,32,23.87,35.18,64.09,1.89,91.1,1.26,25.76-25.76,3.15-28.27-38.27,3.52-61.86-1.7,21-12.13,54.94-7.1,49,6.28,67.23,4.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.5130800000000004px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,305.1s18.31.14,23.33,19,6.91,45.24,7.54,66,1.26,38.33,25.13,43.35,88.59,3.14,106.18-.63,37.07-20.73,22.62-24.5-34.56,0-27,5,27.65,3.77,51.52.63",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.5130800000000004px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.76,370.69s11.19-1,15.56,11.67-1,15.56,1.46,21.88,17.78.42,17.71,5.66c-.07,4.78-6.13,6.13-41.05,4.07-45.66-2.69-75.87,4.38-73.44,8.76s38.91,1,30.15,7.78-30.15-1-46.69-1.46S41,432.45,41,432.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.5130800000000004px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.61,
    y: 192.05,
    width: 117.06,
    height: 215.4,
    rx: 3.56,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.41,
    y: 224.31,
    width: 111.41,
    height: 82.51,
    style: {
      fill: "#616161"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.41,
    y: 320.23,
    width: 111.41,
    height: 82.51,
    style: {
      fill: "#616161"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.75,
    y: 330.28,
    width: 63.25,
    height: 64.5,
    style: {
      fill: "#90CAF9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.75,
    y: 233.53,
    width: 63.25,
    height: 15.92,
    style: {
      fill: "#90CAF9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.75,
    y: 264.1,
    width: 63.25,
    height: 15.92,
    style: {
      fill: "#90CAF9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.88 226.16 141.66 229.51 85.63 229.51 84.41 226.16 72.54 226.16 72.54 240.88 84.41 240.88 85.63 237.53 141.66 237.53 142.88 240.88 156.32 240.88 156.32 226.16 142.88 226.16",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.88 242.22 141.66 245.56 85.63 245.56 84.41 242.22 72.54 242.22 72.54 256.93 84.41 256.93 85.63 253.59 141.66 253.59 142.88 256.93 156.32 256.93 156.32 242.22 142.88 242.22",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.88 258.27 141.66 261.62 85.63 261.62 84.41 258.27 72.54 258.27 72.54 272.99 84.41 272.99 85.63 269.64 141.66 269.64 142.88 272.99 156.32 272.99 156.32 258.27 142.88 258.27",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.88 274.32 141.66 277.67 85.63 277.67 84.41 274.32 72.54 274.32 72.54 289.04 84.41 289.04 85.63 285.7 141.66 285.7 142.88 289.04 156.32 289.04 156.32 274.32 142.88 274.32",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.88 290.38 141.66 293.72 85.63 293.72 84.41 290.38 72.54 290.38 72.54 305.1 84.41 305.1 85.63 301.75 141.66 301.75 142.88 305.1 156.32 305.1 156.32 290.38 142.88 290.38",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.88 322.49 141.66 325.83 85.63 325.83 84.41 322.49 72.54 322.49 72.54 337.2 84.41 337.2 85.63 333.86 141.66 333.86 142.88 337.2 156.32 337.2 156.32 322.49 142.88 322.49",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.88 338.54 141.66 341.89 85.63 341.89 84.41 338.54 72.54 338.54 72.54 353.26 84.41 353.26 85.63 349.92 141.66 349.92 142.88 353.26 156.32 353.26 156.32 338.54 142.88 338.54",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.88 354.6 141.66 357.94 85.63 357.94 84.41 354.6 72.54 354.6 72.54 369.31 84.41 369.31 85.63 365.97 141.66 365.97 142.88 369.31 156.32 369.31 156.32 354.6 142.88 354.6",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.88 370.65 141.66 374 85.63 374 84.41 370.65 72.54 370.65 72.54 385.37 84.41 385.37 85.63 382.02 141.66 382.02 142.88 385.37 156.32 385.37 156.32 370.65 142.88 370.65",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.88 386.71 141.66 390.05 85.63 390.05 84.41 386.71 72.54 386.71 72.54 401.42 84.41 401.42 85.63 398.08 141.66 398.08 142.88 401.42 156.32 401.42 156.32 386.71 142.88 386.71",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.65,
    y: 309.39,
    width: 106.65,
    height: 10.05,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.65,314.31a2.81,2.81,0,1,0-2.81,2.81A2.81,2.81,0,0,0,58.65,314.31Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.2,
    cy: 314.31,
    r: 2.81,
    style: {
      fill: "#90CAF9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.37,314.31a2.81,2.81,0,1,0-2.81,2.81A2.81,2.81,0,0,0,77.37,314.31Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.65,
    y: 213.06,
    width: 106.65,
    height: 10.05,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.65,218a2.81,2.81,0,1,0-2.81,2.81A2.81,2.81,0,0,0,58.65,218Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,218a2.81,2.81,0,1,0-2.81,2.81A2.81,2.81,0,0,0,68,218Z",
    style: {
      fill: "#90CAF9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.37,218a2.81,2.81,0,1,0-2.81,2.81A2.81,2.81,0,0,0,77.37,218Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.65,
    y: 200.13,
    width: 106.65,
    height: 10.05,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.65,205.05a2.81,2.81,0,1,0-2.81,2.81A2.81,2.81,0,0,0,58.65,205.05Z",
    style: {
      fill: "#90CAF9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,205.05a2.81,2.81,0,1,0-2.81,2.81A2.81,2.81,0,0,0,68,205.05Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.37,205.05a2.81,2.81,0,1,0-2.81,2.81A2.81,2.81,0,0,0,77.37,205.05Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.92,
    y: 226.41,
    width: 17.59,
    height: 7.54,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.92,
    y: 242.74,
    width: 17.59,
    height: 7.54,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.92,
    y: 259.08,
    width: 17.59,
    height: 7.54,
    style: {
      fill: "#90CAF9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.92,
    y: 275.41,
    width: 17.59,
    height: 7.54,
    style: {
      fill: "#90CAF9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.92,
    y: 291.75,
    width: 17.59,
    height: 7.54,
    style: {
      fill: "#90CAF9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.92,
    y: 322.32,
    width: 17.59,
    height: 7.54,
    style: {
      fill: "#90CAF9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.92,
    y: 338.66,
    width: 17.59,
    height: 7.54,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.92,
    y: 354.99,
    width: 17.59,
    height: 7.54,
    style: {
      fill: "#90CAF9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.92,
    y: 371.33,
    width: 17.59,
    height: 7.54,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.92,
    y: 387.66,
    width: 17.59,
    height: 7.54,
    style: {
      fill: "#90CAF9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.84,146.36s-16.86,4.29-21.54,10.7-23.65,50-23.65,50-6.15,6.9.5,13.55,19.95,9.11,24.88,3.2,12.06-33.75,13.05-36.95,8.37-30.3,9.11-31.77S218.64,147.24,214.84,146.36Z",
    style: {
      fill: "#bdbdbd",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.84,146.36s-16.86,4.29-21.54,10.7c-2.83,3.87-10.89,21.37-16.82,34.58,2.88-.58,14.88-2.36,28.93,4.72,1.35-4.72,2.35-8.45,2.67-9.5,1-3.2,8.37-30.3,9.11-31.77S218.64,147.24,214.84,146.36Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.24,89.57a16.14,16.14,0,0,1,6.65,7.14c2,4.68,2,11.82,2,11.82s31.53-1,43.6-1.23,20.2,2.71,20.44,8.62-2.46,17.49-9.11,21.92-27.34-2.71-37.93-5.66-14.29-2-21.92-3-9.86-3.94-11.09-8.62,1.23-13.55,1.23-20.69S257.1,88.09,264.24,89.57Z",
    style: {
      fill: "#bdbdbd",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.3,119.86s-4.43,11.33-12.56,17.49c-5.83,4.42-13.7,6.94-17.67,8-14.21-4-34.27-5.88-46-3.28,0,0-16.38,3.92-19.23,4.28s-9.62,23.15-11.05,38.82,3.21,54.5,3.21,57.35,1.78,50.23,4.63,63.41,6.06,31,6.41,33.48,2.85,21,2.85,27.07S218,387.15,218,387.15s-12.82,8.55-17.81,13.53,3.67,10.24,10,11.4c10.74,2,23.5-8.55,23.5-8.55L248,397.84c3.79-1.52,4.91-5.59,5-9.24l.66-26.38q3.36,14,5.52,28.29c.58,3.9,1.18,8,3.53,11.15a15.18,15.18,0,0,0,4.94,4.39c1.42.66,2.93.52,4.36,1.34,2.63,1.52,3.71,4.8,6.26,6.45a33.51,33.51,0,0,0,18.17,4.65s14.24.72,15-7.12-18.53-20.66-18.53-20.66-2.85-52-5-69.1-7.84-44.88-7.84-57,5.7-69.11,5.7-69.11.58-1.5,1.47-3.94l.94-.52c8.13-4.68,30.79-22.91,38.18-34.49,7.08-11.08,9.64-31.87,9.84-37.95",
    style: {
      fill: "#bdbdbd",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.37,411.37c.71-7.84-18.53-20.66-18.53-20.66s-.22-4-.58-10.15a143.77,143.77,0,0,1-34.08,4q.51,3,1,6c.58,3.9,1.18,8,3.53,11.15a15.18,15.18,0,0,0,4.94,4.39c1.42.66,2.93.52,4.36,1.34,2.63,1.52,3.71,4.8,6.26,6.45a33.51,33.51,0,0,0,18.17,4.65S310.65,419.21,311.37,411.37Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,397.84c3.79-1.52,4.91-5.59,5-9.24,0-1.38.07-2.76.1-4.14a157.47,157.47,0,0,1-33.69-4.82c-.68,4.16-1.34,7.51-1.34,7.51s-12.82,8.55-17.81,13.53,3.67,10.24,10,11.4c10.74,2,23.5-8.55,23.5-8.55Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.37,411.37c0-.11,0-.23,0-.35a24.49,24.49,0,0,1-10.61,4.3c-11.26,2-21.52-3.75-24.27-6.25s-4.5-4.51-8.76-7.26-8.11-9.52-8.11-9.52l-.16.25c.53,3.25,1.27,6.5,3.22,9.12a15.18,15.18,0,0,0,4.94,4.39c1.42.66,2.93.52,4.36,1.34,2.63,1.52,3.71,4.8,6.26,6.45a33.51,33.51,0,0,0,18.17,4.65S310.65,419.21,311.37,411.37Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,397.84c3.31-1.33,4.58-4.59,4.92-7.82-3.28,2-10.86,6.37-15.67,8.29-6.25,2.5-10.51,10-22.76,10-8.74,0-13.53-3.42-15.56-5.39-1.08,4.22,6,8.17,11.32,9.16,10.74,2,23.5-8.55,23.5-8.55Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.23,139.67a61.36,61.36,0,0,1-14.16,5.69c-14.21-4-34.27-5.88-46-3.28,0,0-16.38,3.92-19.23,4.28s-9.62,23.15-11.05,38.82c-.88,9.68.55,28.16,1.77,41.57,29.69,10.88,61.35,7.15,76.83,4.19,1.56-17.76,3.33-35.43,3.33-35.43s.58-1.5,1.47-3.94l.94-.52c5.53-3.18,17.75-12.61,27.34-22C296.22,163.5,293.89,148.32,294.23,139.67Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.63,156.66a19,19,0,0,0-8.1-15.19c-9.1-.88-18-.82-24.46.61,0,0-4.53,1.09-9.24,2.16a18.35,18.35,0,0,0-5,12.42c0,11.11,10.48,20.12,23.4,20.12S266.63,167.77,266.63,156.66Z",
    style: {
      fill: "#616161",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.62,392.29a42.6,42.6,0,0,0,16.66,2.34c12.29-.53,16.56-3.92,16.56-3.92s-2.85-52-5-69.1-7.84-44.88-7.84-57c0-7.14,2-29.87,3.61-47.33l-.77.09a14.35,14.35,0,0,1-16-14.68l.34-11.37a148.24,148.24,0,0,1-27.79-.8c-16.56-1.87-33.66-7.48-33.66-7.48l-1.8.55c0,.53-.11,1.06-.16,1.58-1.42,15.68,3.21,54.5,3.21,57.35s1.78,50.23,4.63,63.41,6.06,31,6.41,33.48,2.85,21,2.85,27.07-2.74,20.12-2.84,20.64c2.14.66,6.62,2,14.69,4.29,12.28,3.48,20.21-.71,20.21-.71,0-4.27.71-28.49.71-28.49S258.16,382.71,259.62,392.29Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.93 198.05 250.92 203.31 250.92 223.03 232.95 241.01 218.49 223.47 218.93 198.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,308.94c-2.31-13-4-25.84-4-35.06l-12.82-8.55",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.66,362.22s-5.4-20.87-9.86-43.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.19,251.73a13.31,13.31,0,0,0,1.32,3.3c3.95,7,9.64,7.89,9.64,7.89l.88-18.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.51,241a15.67,15.67,0,0,0-1.45,4.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.22,297c.46,2.43.93,4.82,1.39,7.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.15,262.92s2.26,13.51,4.87,27.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,134.5,231.8,145s-3.62,2.9-4.34,10.5,6.52,14.67,14.66,14.67,15.21-6.34,16.48-12.13-.37-14.12-.37-14.12l-.54-12.67s-8,5.06-15.57,3.62-9.77-4.17-9.77-4.17Z",
    style: {
      fill: "#bdbdbd",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.31,107.1s-.49,6,.81,7.47,3.09,2.6,3.42,1.3.48-8.12.81-9.58S226.47,103,226.31,107.1Z",
    style: {
      fill: "#bdbdbd",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.49,107S228,119,228,124.81s-2.25,8,5,11.78,13.53,4.26,18.54,2.5,7.77-6,8-9.52.25-9,.25-9,7-6.26,5.52-11-4.76,1.25-4.76,1.25a38.69,38.69,0,0,0,2-12.78c-.25-6.52-5.26-7.27-7.27-7.27S241,87,235.25,90.72,229.49,107,229.49,107Z",
    style: {
      fill: "#bdbdbd",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.57,110.77a38.69,38.69,0,0,0,2-12.78c-.25-6.52-5.26-7.27-7.27-7.27h-.13c-1.06,1.78-2.37,4.52-2.37,4.52l1,.5s-1,5.52,1,6.27,1,2.5,1,5.51,1.76,5.26,2.76,5.26c.79,0,2-2,2.54-2.87C260.77,110.39,260.57,110.77,260.57,110.77Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.77,111.49s-2.11,1.94-1.14,3.41,4.55,2.27,5.53.48a3,3,0,0,0-.65-3.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.5,109.54c0,1-.4,1.78-.9,1.78s-.89-.8-.89-1.78.4-1.79.89-1.79S238.5,108.55,238.5,109.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.3,110c0,1-.4,1.79-.89,1.79s-.9-.8-.9-1.79.4-1.78.9-1.78S249.3,109,249.3,110Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.62,105.15s3.41-2.28,6.66,1.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.44,121.14a3.39,3.39,0,0,0-2.78-.12,2.87,2.87,0,0,0-1.62,1.74s-2.08,1.67.11,2.4,7,.68,8.21.63a1.87,1.87,0,0,0,1.6-2.07,1.12,1.12,0,0,0-.51-1A4,4,0,0,0,241.44,121.14Z",
    style: {
      fill: "#666",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.922744px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.57,123.39a23.55,23.55,0,0,1,10.09.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0732700000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.23,93.23,252.05,97s11.27-3,12.28-5.26-2.76-13.53-4.77-16.29-21.3,2-27.32,3S221.72,80.94,222,84,225.23,93.23,225.23,93.23Z",
    style: {
      fill: "#90CAF9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.23,93.23S209.94,105.76,209.69,107s22.3,1.75,29.32.25,13-10.28,13-10.28Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.52,259.36l42-24.63a8.28,8.28,0,0,0,12.91-8.95l-8.77,5.13-2-3.45,8.78-5.14a8.28,8.28,0,0,0-14.13,6.88l-42.05,24.63a8.28,8.28,0,0,0-12.91,8.95l8.54-5,2,3.46-8.54,5a8.27,8.27,0,0,0,14.12-6.88Z",
    style: {
      fill: "#90CAF9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.29,241.05s5.17,3.7,5.17,7.14-6.16,7.15-10.34,7.39-4.93-4.43-4.19-6.89S244.29,241.05,244.29,241.05Z",
    style: {
      fill: "#bdbdbd",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.1,210.26s28.57,16,32.51,15.52,9.36-3.94,12.32-3,11.08,13.55,11.82,15.77-5.91,10.1-7.39,11.33-6.16,6.16-7.14,6.65-7.39,6.16-10.59,6.16-8.62-2.47-9.12-3.7.74-2.95.74-2.95l-15-6.9s-28.58-15.52-33.5-23.4,7.39-21.92,7.39-21.92",
    style: {
      fill: "#bdbdbd",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.11,248.93a4,4,0,0,1,3.44,3.45c.5,3.2-.74,8.87-.74,8.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.77,244.25s3.45.25,3.45,3.45v8.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.47,235.39s6.4,4.68,6.89,7.39a31.36,31.36,0,0,1,0,7.14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,218.5c1.44,0,5.25-9.54,5.25-13.12s1.67-29.81,5.49-42c2.74-8.73,5.1-15.47,6.22-18.6-2.91-.74-6-1.4-9.22-2-1.91,5.79-7.74,23.86-10.12,35.35-2.86,13.83-2.15,30.29-1.91,31.72S259.59,218.5,261,218.5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.25,
    y: 189.64,
    width: 10.73,
    height: 9.06,
    rx: 1.23,
    transform: "matrix(0.99, 0.13, -0.13, 0.99, 27.82, -32.73)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.25,
    y: 191.33,
    width: 6.73,
    height: 5.69,
    rx: 1.23,
    transform: "translate(27.82 -32.73) rotate(7.56)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.59,214.92c1.44,0,5.25-9.54,5.25-13.12s1.67-29.81,5.49-42c2.42-7.72,4.07-12.65,5-15.22-3.73.84-7.27,1.61-8.45,1.76-.88.11-2.12,2.34-3.47,5.82-1.58,4.9-3.51,11.27-5,17.48a128.67,128.67,0,0,0-2.55,15.52,132,132,0,0,0-.07,15.73q0,.27.06.42C204,202.76,206.16,214.92,207.59,214.92Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.06,
    y: 182.25,
    width: 10.73,
    height: 9.06,
    rx: 1.23,
    transform: "translate(21 -21.06) rotate(6.09)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.06,
    y: 183.93,
    width: 6.73,
    height: 5.69,
    rx: 1.23,
    transform: "translate(20.99 -21.06) rotate(6.09)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2565400000000002px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerErrorImg);
export default __webpack_public_path__ + "static/media/serverErrorImg.c0f99b1a45734c6b70299f54562ca4fa.svg";
export { ForwardRef as ReactComponent };